<script setup lang="ts">
/**
 * Match pairs, stored ALIGNED: each row is one correct pair (decision 8); the player shuffles the
 * right-hand cards. Right sides must be unique — the player accepts any card with the keyed label.
 */
import type { InputPrimaryEvent } from '@shared/ui/fields'
import type { MathExerciseEditorProps } from '../../../../../model/assignments/math-exercise-editors.hook'

import { AppText } from '@shared/ui/typography'
import { InputPrimary } from '@shared/ui/fields'

import { MATH_PAIRS_MIN } from '../../../../../lib/assignments/math-practice-schema'
import ExerciseItemList from '../ExerciseItemList.vue'

defineOptions({
  name: 'ExerciseMatchPairs',
})

defineProps<MathExerciseEditorProps>()
</script>

<template>
  <div class="exercise-match-pairs">
    <AppText
      name="body2"
      color="slate-500"
    >
      Write each pair on one row, left and its match on the right. The kid sees the right side shuffled.
    </AppText>
    <ExerciseItemList
      :exercise="exercise"
      list="pairs"
      noun="pair"
      label="Pairs"
      :min="MATH_PAIRS_MIN"
    >
      <template #item="{ row, update }">
        <InputPrimary
          name="pair-left"
          class-name="exercise-match-pairs__side"
          :value="row.values.left"
          placeholder="Left"
          @input="(event: InputPrimaryEvent) => update({ left: String(event.value) })"
        />
        <InputPrimary
          name="pair-right"
          class-name="exercise-match-pairs__side"
          :value="row.values.right"
          placeholder="Its match"
          @input="(event: InputPrimaryEvent) => update({ right: String(event.value) })"
        />
      </template>
    </ExerciseItemList>
  </div>
</template>

<style scoped lang="scss" src="./ExerciseMatchPairs.scss" />
